import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { DISABLE_CLOSING_COST_ESTIMATE, LoanFieldProps } from 'config'
import { store } from 'reducers'
import { isEmpty, removeComma } from 'utils'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'
import { determineCreditScore, getCachedCreditReportDefaults } from './determine-credit-score'

export const creditValidate = (borrowerSeperator: BorrowerSeperator, updateStore = false, afterRemoved = false) => {
  const { borrower, step, globalConfigReducer } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})['credit'] === false) {
    return true
  }

  let success = true
  const data = borrower[borrowerSeperator]
  if (!data || !data.creditRequestType || (!data.equifax && !data.experian && !data.transunion)) success = false

  if (afterRemoved) success = false
  if (updateStore) {
    let application = cloneDeep(step.application)
    const key = borrowerMenuKey(borrowerSeperator, 'credit')
    application[key] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }

  return success
}

export const isSameStructureApplicationCreditScore = () => {
  const { loan, borrower, globalConfigReducer, loanDetail } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps

  if (((loanFieldProperties as any)['visibility'] || {})['credit'] === false) {
    return { same: true, value: 0, error: '' }
  }

  let { estimatedCreditScore, isNoScore, productType } = loan
  if (isNoScore) return { same: true, value: 0, error: '' }
  estimatedCreditScore = removeComma(estimatedCreditScore)

  const includeCoborrower = !!(loanDetail?.includeCoborrower ?? loan?.includeCoborrower)
  const visibleByBorrower = (loanFieldProperties as any)['properties']?.['credit']?.['visibleByBorrower'] || {}

  const borrowers = Object.keys(borrower)
    .sort((a, b) => {
      if (a === BorrowerSeperator.BORROWER) return -1
      if (b === BorrowerSeperator.BORROWER) return 1
      return a.localeCompare(b)
    })
    .map((key) => {
      const b = borrower[key]
      const isPrimary = key === BorrowerSeperator.BORROWER
      let isIncluded = isPrimary || (includeCoborrower && b?.isIncluded !== false)
      if (visibleByBorrower?.[key] === false) isIncluded = false
      return { ...b, borrowerSeperator: key, isIncluded }
    })

  const result = determineCreditScore(productType, borrowers, getCachedCreditReportDefaults(), {
    includeCoborrower,
  })

  if (result.isNoScore || result.score == null) {
    return { same: true, value: 0, error: '' }
  }

  const middleValue = result.score
  if (middleValue == estimatedCreditScore) return { same: true, value: middleValue, error: '' }
  return { same: false, value: middleValue, error: `Credit Score does not match Credit Report (${middleValue})` }
}

export const closingCostEstimateIsSameFeeWorksheet = () => {
  const { loan, loanDetail } = store.getState()
  // Enable to Pull Closing Cost Estimate
  if (!DISABLE_CLOSING_COST_ESTIMATE) {
    const closingCostEstimate = removeComma(loanDetail.closingCostEstimate)
    if (removeComma(loan.closingCostEstimate) != closingCostEstimate)
      return { same: false, error: `The Fee Worksheet does not match the input estimate.` }
    else return { same: true, error: '' }
  } else return { same: true, error: '' }
}

export const getPriceScoreOptions = () => {
  const { borrower } = store.getState()
  const options: string[] = []

  Object.keys(borrower).forEach((borrowerSep) => {
    if (!borrower[borrowerSep].isIncluded) return
    ;['equifax', 'transunion', 'experian'].forEach((key) => {
      if (!isEmpty(borrower[borrowerSep][key]) && !options.includes(borrower[borrowerSep][key]))
        options.push(borrower[borrowerSep][key])
    })
  })

  options.sort()

  return options
}
